import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from "@mui/material/Button";
import { Ellipsis } from 'react-spinners-css';

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserratbold",
                    fontSize: '1rem',
                    padding: '5px 8px',
                    borderRadius: '4',
                },
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        zIndex: '999',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        display: 'flex',
    },
    effect: {
        position: 'relative',
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        background: 'linear-gradient(90deg, #614F41, #181A17)',
    },

    eventsPanel: {
        padding: '26px 0 26px 0',

        [theme.breakpoints.up('lg')]: {
            padding: '46px 0 46px 0',
        }
    },

    content: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        flexDirection: 'column',

        [theme.breakpoints.up('md')]: {
            width: '862px',
        },

        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
            width: '1082px',
        }
    },
    photoContent: {
        display: 'flex',
        justifyContent: 'center',
        padding: '48px 36px 0px 36px',

        [theme.breakpoints.up('lg')]: {
            padding: '40px 0px 40px 0px',
        }
    },
    photo: {
        width: '100%',

        '& img': {
            width: '100%',
        },

        [theme.breakpoints.up('lg')]: {
            width: '482px',
        },
    },
    textContent: {
        textAlign: 'left',
        padding: '20px 16px 46px 16px',

        [theme.breakpoints.up('md')]: {
            padding: '46px 0px 46px 0px',
        },

        [theme.breakpoints.up('lg')]: {
            padding: '26px 100px 26px 50px',
        },
    },
    title: {
        fontFamily: 'Divona',
        fontSize: '2.7em',
        lineHeight: '1.2em',
        color: '#FFE0BD',
    },
    subtitle: {
        fontFamily: 'montserratbold',
        letterSpacing: '0.1em',
        margin: '12px 0',
        textTransform: 'uppercase',
        color: '#FFF',
    },
    text: {
        margin: '0 0 20px 0',
        color: '#FFF',
    },
    photoFrameMobile: {
        display: 'block',

        [theme.breakpoints.up('lg')]: {
            display: 'none',
        }
    },
    photoFrameDesktop: {
        display: 'none',

        [theme.breakpoints.up('lg')]: {
            display: 'block',
        }
    },
    loaderContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
});

class EventsPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            jsonEvents: []
        }
    }

    componentDidMount() {
//        fetch('http://192.168.1.114:8888/projects/Trailburning/tb-adelaidewingchunacademy/server/events.php')
        fetch('https://adelaidewingchunacademy.com.au/server/events.php')
            .then(response => response.json())
            .then(data => {
//                console.log(data);
                this.setState({jsonEvents: data});
            })
    }

    render() {
        const { classes } = this.props;
        let self = this;

        function RenderEventButton(props) {
            if (props.active) {
                return (
                    <a href={props.url} target="_blank"><Button variant="contained">Get Tickets</Button></a>
                )
            }

            return (
                <Button disabled={true} variant="contained">Get Tickets</Button>
            )
        }

        function RenderEvents() {
            if (self.state.jsonEvents.length) {
                return (
                    <div>
                    {self.state.jsonEvents.map(item => {
                        return (

                            <div className={classes.content} key={item.id}>

                                <div className={classes.photoFrameMobile}>
                                    <div className={classes.photoContent}>
                                        <div className={classes.photo}><img src={item.image} /></div>
                                    </div>
                                </div>

                                <div className={classes.textContent}>
                                    <div className={classes.title}>{item.name}</div>
                                    <div className={classes.subtitle}>{item.date} {item.time}</div>
                                    <div className={classes.text}>
                                        {item.venue}<br/>
                                        {item.location}</div>
                                    <RenderEventButton url={item.url} active={item.active} />
                                </div>

                                <div className={classes.photoFrameDesktop}>
                                    <div className={classes.photoContent}>
                                        <div className={classes.photo}><img src={item.image} /></div>
                                    </div>
                                </div>

                            </div>
                        )
                    })}
                    </div>
                )
            }

            return (
                <div className={classes.loaderContainer}><Ellipsis color="#FF2E28"/></div>
            )
        }

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.panel}>
                <div className={classes.effect}>

                    <div className={classes.eventsPanel}>
                    <RenderEvents />
                    </div>

                </div>
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(EventsPanel)